import React, { Component } from "react";
import './home.css';
import { NavLink } from 'react-router-dom';

interface HomeTemplate {

    firstTerminalText: any,
    secondTerminalText: any,
    classes: any

}

export default class Home extends Component<any, HomeTemplate> {

    secondContainerFirstPart: any;
    secondContainerSecondPart: any;
    firstTerminalText: any;
    secondTerminalText: any;
    secondContainerFirstPartProps: any;
    secondContainerSecondPartProps: any;
    terminalTextIndicator: any;
    terminalTextIndicatorTwo: any;
    numberOfLines: any;

    constructor(props: any) {

        super(props)
        this.inView = this.inView.bind(this);
        this.scrolling = this.scrolling.bind(this);
        this.firstTerminalText = "1_let_firstMessage_=_'Hello_$World!'_;_2_console_._log_(_firstMessage_)_;_3_|";
        this.secondTerminalText = "$ git status_On branch master_Changes not staged for commit:_(use 'git add <file>...' to update what will be commited)_(use 'git checkout -- <file>...' to discard changes in working directory)_&modified index.html_no changes added to commit (use 'git add' and/or 'git commit-a')_$ |";
        this.numberOfLines = 1;
        this.state = { classes: [
            {
                secondContainerFirstPart: {
                    right: "invisible inactiveComponentRight",
                    left: "invisible inactiveComponentLeft",
                }
            }, 
                {
                secondContainerSecondPart: {
                    right: "invisible inactiveComponentRight",
                    left: "invisible inactiveComponentLeft"
                }
            },
        ], firstTerminalText: "", secondTerminalText: "" };
        this.secondContainerFirstPart = React.createRef();
        this.secondContainerSecondPart = React.createRef();

    }

    firstTerminalCode() {

        let code = this.firstTerminalText;

        this.terminalTextIndicator = setInterval(() => {

            if (code.length > 0) {

                let char = code.charAt(0);

                this.setState({
                    classes: this.state.classes,
                    firstTerminalText: this.state.firstTerminalText + char
                });

                if (code.charAt(0) === ";") {

                    this.numberOfLines = this.numberOfLines + 1;

                }

                code = code.substring(1);

            }

            else {

                clearInterval(this.terminalTextIndicator);

            }

        }, 150);

    }

    secondTerminalCode() {

        let code = this.secondTerminalText;

        this.terminalTextIndicatorTwo = setInterval(() => {

            if (code.length > 0) {

                let char;

                if (code.length >= 7) {

                    char = code.substring(0, 6);

                    code = code.substring(6);

                }

                else {

                    char = code.substring(0, code.length);

                    code = code.substring(code.length);

                    clearInterval(this.terminalTextIndicatorTwo);

                }

                this.setState({
                    classes: this.state.classes,
                    firstTerminalText: this.state.firstTerminalText,
                    secondTerminalText: this.state.secondTerminalText + char

                });


            }

            else {

                clearInterval(this.terminalTextIndicatorTwo);

            }

        }, 100);

    }

    public componentDidMount() {

        document.addEventListener('scroll', this.scrolling);

        this.secondContainerFirstPartProps = this.secondContainerFirstPart.current;
        this.secondContainerSecondPartProps = this.secondContainerSecondPart.current;

    }

    public componentWillUnmount() {

        document.removeEventListener('scroll', this.scrolling);

        if (this.terminalTextIndicator != null) {

            clearInterval(this.terminalTextIndicator);

        }

        if (this.terminalTextIndicatorTwo != null) {

            clearInterval(this.terminalTextIndicatorTwo);

        }

    }

    public scrolling() {

        let currentLocation = this.inView();

        let updateStateRequired = false;

        if (currentLocation[0].secondContainerFirstPart?.right == "visible") {

            currentLocation[0].secondContainerFirstPart!.right = "activeComponentRight fadeInRight";
            currentLocation[0].secondContainerFirstPart!.left = "activeComponentLeft fadeInLeft";

            if (this.terminalTextIndicator == null) {
                
                this.firstTerminalCode();

                updateStateRequired = true;

            }

        }

        else {

            currentLocation[0].secondContainerFirstPart!.right = "invisible inactiveComponentRight fadeInRightReverse";
            currentLocation[0].secondContainerFirstPart!.left = "invisible inactiveComponentLeft fadeInLeftReverse";

            if (this.terminalTextIndicator != null) {

                clearInterval(this.terminalTextIndicator);

                this.setState({ 
                    classes: this.state.classes,
                    firstTerminalText: "",
                    secondTerminalText: this.state.secondTerminalText
                })

                updateStateRequired = true;
    
                this.numberOfLines = 1;
                this.terminalTextIndicator = null;

            }

        }

        if (currentLocation[1].secondContainerSecondPart?.right == "visible") {

            currentLocation[1].secondContainerSecondPart.right = "activeComponentRight fadeInRight";
            currentLocation[1].secondContainerSecondPart.left = "activeComponentLeft fadeInLeft";

            if (this.terminalTextIndicatorTwo == null) {

                this.secondTerminalCode();

                updateStateRequired = true;

            }

        }

        else {

            currentLocation[1].secondContainerSecondPart!.right = "invisible inactiveComponentRight";
            currentLocation[1].secondContainerSecondPart!.left = "invisible inactiveComponentLeft";

            if (this.terminalTextIndicatorTwo != null) {

                clearInterval(this.terminalTextIndicatorTwo);

                currentLocation[1].secondContainerSecondPart!.right = "invisible inactiveComponentRight fadeInRightReverse";
                currentLocation[1].secondContainerSecondPart!.left = "invisible inactiveComponentLeft fadeInLeftReverse";

                this.setState({ 
                    classes: this.state.classes,
                    firstTerminalText: this.state.firstTerminalText,
                    secondTerminalText: ""
                })

                updateStateRequired = true;
                this.terminalTextIndicatorTwo = null;

            }

        }

        if (updateStateRequired) {

            this.setState({
                classes: [{
                    secondContainerFirstPart: {
                        right: currentLocation[0].secondContainerFirstPart?.right,
                        left: currentLocation[0].secondContainerFirstPart?.left

                    }

                },

                {
                    secondContainerSecondPart: {
                        right: currentLocation[1].secondContainerSecondPart?.right,
                        left: currentLocation[1].secondContainerSecondPart?.left,
                    }

                }
            
            ],
            firstTerminalText: this.state.firstTerminalText,
            secondTerminalText: this.state.secondTerminalText
            });

        }

    }

    public inView() {
        
        let view = [
            {
                secondContainerFirstPart: {
                    right: "invisible",
                    left: "invisible",
                }
            },

            {
                secondContainerSecondPart: {
                    right: "invisible",
                    left: "invisible"
                }
            }
    
        ]

        let terminalOne = this.secondContainerFirstPartProps.getBoundingClientRect();
        // let terminalHeight = this.secondContainerFirstPartProps.offsetHeight;

        if ((window.innerHeight || document.documentElement.clientHeight) > terminalOne.top && terminalOne.bottom >= (window.innerHeight / 5)) {

            view[0].secondContainerFirstPart!.right = "visible"
            view[0].secondContainerFirstPart!.left = "visible"

        }

        let terminalTwo = this.secondContainerSecondPartProps.getBoundingClientRect();
        // let terminalTwoHeight = this.secondContainerSecondPartProps.offsetHeight;

        if ((window.innerHeight || document.documentElement.clientHeight) > terminalTwo.top && terminalTwo.bottom >= (window.innerHeight / 5)) {


            view[1].secondContainerSecondPart!.right = "visible";
            view[1].secondContainerSecondPart!.left = "visible";

        }

        return view;

    }

    openUrl = (link: string) => {

        window.open(link, '_blank');

    }

    public highlightText(text: any, index: number) {

        let additionalText = false;

        if (text.charAt(0) == "$") {

            text = text.substring(1);
            additionalText = true;

        }

        if (text >= 0) {

            if (this.numberOfLines == text) {

                return <span key={index} className={"writingLine"}>{text} </span>

            }

            else {

                return <span key={index} className={"otherLines"}>{text} </span>

            }


        }

        else if (text === 'let') {

            return <span key={index} className={"variableDec"}>{text} </span>

        }

        else if (text.charAt(0) === "'" && text.charAt(text.length - 1) != "'") {

            return <span key={index} className={"string"}>{text} </span>

        }

        else if (text.charAt(text.length - 1) === "'") {

            return <span key={index} className={"string"}>{text}</span>

        }

        else if (text === "=") {

            return <span key={index} className={"remaining"}> {text} </span>

        }

        else if (text === "(" || text === ")" || text === ".") {

            return <span key={index} className={"remaining"}>{text}</span>

        }

        else if (text === ";") {

            return <span key={index} className={"remaining"}>{text} <br /> </span>

        }

        else if (text === "log") {

            return <span key={index} className={"function"}>{text}</span>

        }

        else if (text === "console") {

            return <span key={index} className={"variableName"}>{text}</span>

        }

        else if (additionalText) {

            return <span key={index} className={"string"}>{text}</span>

        }

        else if (text === "|") {

            return <span key={index} className={"terminalTextIndicator"}>{text}</span>

        }

        else {

            return <span key={index} className={"variableName"}>{text}</span>

        }

    }

    public highlightGit(text: any, index: number) {

        let highlight = false;

        if (text.charAt(0) === "&") {

            text = text.substring(1);
            highlight = true;

        }

        if (highlight) {

            return <span key={index} className="gitHighlight"> {text} <br/></span>

        }

        else if (text === "$ |") {

            return <span key = {index}>$ <span className = "terminalTextIndicator">|</span></span>

        }

        else {

            return <span key={index}>{text} <br/> </span>

        }

    }

    public render() {

        return (
            <div id="home">

                <div id="welcome">

                    <div id="homeGraphics">

                        <div id="homeGraphics1">

                        </div>

                    </div>

                    <div id="welcomeBackground">

                    </div>

                    <div id="welcomeTitle">

                        <div id="welcomeImageContainer">

                        </div>
                        <div id="welcomeText">

                            <div id="welcomeTitleHeader">Practice makes perfect!</div>
                            <div id="welcomeTitleSecondary">Join the thousands of others who yearn to improve their coding skills.</div>
                            <NavLink to ="/javascript" exact><button id="welcomeButtons">Let's start!</button></NavLink>
                            <NavLink to ="/about" exact><button id="welcomeButtons">ABOUT</button></NavLink>

                        </div>

                    </div>

                </div>

                <div id="secondContainer">

                    <div id="containerBox">

                        <div ref={this.secondContainerFirstPart} id="secondContainerFirstPart">

                            <div id="firstDescription" className={this.state.classes[0].secondContainerFirstPart.left}>

                                <div id="descriptionTitle">Download a compiler</div>
                                <div id="description">It is recommended to download a code editor for easier building and debugging applications.</div>
                                <div id="description">A recommended open source code editor would be Visual Studio Code:</div>
                                <button id="descriptionButton" onClick = {() => this.openUrl("https://code.visualstudio.com/download")}>Free Download</button>

                            </div>

                            <div id="firstTerminal" className={this.state.classes[0].secondContainerFirstPart.right}>

                                <div id="terminalText">

                                    {this.state.firstTerminalText.split("_").map((value: any, index: any, array: any) => {

                                        return (this.highlightText(array[index], index));

                                    })}

                                </div>
                                
                            </div>
                        </div>

                        <div ref = {this.secondContainerSecondPart} id = "secondContainerSecondPart">

                            <div id = "secondTerminal" className={this.state.classes[1].secondContainerSecondPart.left}>

                                <div id = "terminalText">

                                    {this.state.secondTerminalText.split("_").map((value: any, index: any, array: any) => {

                                        return (this.highlightGit(array[index], index));

                                    })}

                                </div>

                            </div>

                            <div id = "secondDescription" className={this.state.classes[1].secondContainerSecondPart.right}>

                                <div id="descriptionTitle">Download Git</div>
                                <div id="description">Git is an open source distributed version control system that helps with code management, teamwork coordination and change detection.</div>
                                <div id="description">Downloading Git is highly recommendable, as it can speed up the workflow or improve consistency and bug detections</div>
                                <button id="descriptionButton">Free Download</button> <button id ="descriptionButton">Study Syntax</button>

                            </div>

                        </div>

                        <div id="thirdContainerFirstPart">

                            <div className="timeline">
                                <div className="container left">
                                    <div className="contentLeft">
                                        <h2>Pick your first programming language</h2>
                                        <p>While syntax may vary, most programming languages function very similarly.</p>
                                        <p>Once you get used to the thinking patterns required to efficiently use a programming language, learning other ones would be relatively easy, for the most part.</p>
                                    </div>
                                </div>
                                <div className="container right">
                                    <div className="contentRight">
                                        <h2>Don't try to memorize the syntax</h2>
                                        <p>While knowing the syntax is important, it will always be available to you throughout the internet. You should focus more on adapting your way of thinking so that you'd be able to implement your desired goals.</p>
                                    </div>
                                </div>
                                <div className="container left">
                                    <div className="contentLeft">
                                        <h2>Don't be afraid of looking for solutions online</h2>
                                        <p>There are plenty of ways to implement the very same application.</p>
                                        <p>Looking for different solutions throughout the internet is highly recommended.</p>
                                        <p>However, study the code you are copying. Certain solutions may be wrong or inefficient, and just copying other programmers' work wouldn't get you anywhere in the long run.</p>
                                        <p>Use any time you look around the internet for solutions for enhancing your own skills.</p>
                                    </div>
                                </div>
                                <div className="container right">
                                    <div className="contentRight">
                                        <h2>Being a great programmer is a never-ending process</h2>
                                        <p>Don't get discouraged.</p>
                                        <p>Progammers have to constantly study new frameworks, programming languages and new techologies in order to enhance their skills and stay relevant.</p>
                                        <p>High-tech is an industry that always evolves, and because of that, you should always aim on improving.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


        </div>

        );
    }
}